export const TEACHER_DASHBOARD_FEATURED_BLOG_POST_ID = '51'
export const MY_CLASSES_FEATURED_BLOG_POST_ID = '137';
export const MY_ACTIVITIES_FEATURED_BLOG_ID = '519';
export const ASSIGN_ACTIVITIES_FEATURED_BLOG_ID = '113';
export const ACTIVITY_ANALYSIS_FEATURED_BLOG_ID = '628';
export const ACTIVITY_SUMMARY_FEATURED_BLOG_POST_ID = '1037';
export const DIAGNOSTICS_FEATURED_BLOG_POST_ID = '564';
export const RESULTS_AND_RECOMMENDATIONS_FEATURED_BLOG_POST_ID = '449';
